import React, { Component } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import styles from './dashboard.module.sass';
import Widget from '../Widget';
import DetailsModal from './DetailsModal';
import { DashboardShape, WidgetShape } from '../../../../shapes';

export class Dashboard extends Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    const { match } = this.props;
    this.props.loadWidgets();
    this.props.loadDashboardDetails(match?.params?.id);
    document.title = 'Dashboard - Silent Push';
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match?.params?.id;
    const oldId = prevProps.match?.params?.id;
    if (id !== oldId) {
      this.props.loadDashboardDetails(id);
    }
  }

  handleCreateClick = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = (data) => {
    this.props.createDashboard(data);
    this.handleModalClose();
  };

  handleWidgetUpdate = (widget, cell) => {
    const { dashboard } = this.props;
    this.props.updateDashboardCell({
      dashboard: dashboard.uuid,
      uuid: cell.uuid,
      widget: widget || null,
    });
  };

  render() {
    const { dashboard, dashboards, widgets } = this.props;
    const { showModal } = this.state;
    if (!dashboard) return null;

    if (!dashboard.rows) return null;
    return (
      <div className={styles.container}>
        <DetailsModal
          dashboards={dashboards}
          show={showModal}
          onCancel={this.handleModalClose}
          onSubmit={this.handleSubmit}
        />
        <div className={styles.top_section}>
          <h1>{dashboard.name}</h1>
          <Button type="primary" onClick={this.handleCreateClick}>
            + Add New Dashboard
          </Button>
        </div>
        <div className={styles.widgets_container}>
          {dashboard.rows.map((row) => (
            <div className={styles.row}>
              {row.cells.map((cell) => (
                <Widget
                  size={cell.size}
                  availableWidgets={widgets}
                  key={cell.size + cell.position}
                  widget={cell.widget}
                  onUpdate={(widget) => this.handleWidgetUpdate(widget, cell)}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
Dashboard.propTypes = {
  createDashboard: PropTypes.func.isRequired,
  loadWidgets: PropTypes.func.isRequired,
  updateDashboardCell: PropTypes.func.isRequired,
  loadDashboardDetails: PropTypes.func.isRequired,
  dashboard: DashboardShape.isRequired,
  dashboards: PropTypes.arrayOf(DashboardShape).isRequired,
  widgets: PropTypes.arrayOf(WidgetShape).isRequired,
  match: PropTypes.object.isRequired,
};

export default Dashboard;
